
<template>
  <div>
    <CRow>
      <CCol lg="12">
        <CCard>
          <CCardHeader>
            <strong>{{getDisplayName()}}</strong> の
            ポイント更新
          </CCardHeader>
          <CCardBody>
            <CForm>
              <div class="user-info-table">
                <dl class="row">
                  <dt class="col-sm-12">
                    <h4 class="sub-title">ポイント更新</h4>
                  </dt>
                </dl>
                <dl class="row r-content">
                  <dd class="col-sm-8">
                    <dl class="row sub-r-content">
                      <dt class="col-sm-3">ポイント</dt>
                      <dd class="col-sm-9">
                        <dl class="row w-100 ml-1 sub-r-content">
                          <dt class="col-sm-3">
                            (更新前)
                          </dt>
                          <dd class="col-sm-9">
                            {{tableItems.points}}<br>
                          </dd>
                        </dl>
                        <dl class="row w-100 ml-1 sub-r-content">
                          <dt class="col-sm-3">
                            (更新後)
                          </dt>
                          <dd class="col-sm-9">
                            {{calcAfterPoints()}}
                          </dd>
                        </dl>
                        <div class="text-danger" v-if="!$v.afterPoints.minValue">更新後のポイントを0以上にしてください。</div>
                      </dd>
                      
                      <dt class="col-sm-3">更新値</dt>
                      <dd class="col-sm-4">
                        <CButton
                          @click="swichIncrease()"
                          variant="outline"
                          class="ff-button sm bg-info"
                        >
                          {{increaseButton}}
                        </CButton>

                        <CInput
                          numeric
                          horizontal
                          required
                          v-model="itemToEdit.points"
                          class="w-50"
                        />
                        <div class="text-danger" v-if="!$v.itemToEdit.points.required">更新値は必須です。</div>
                        <div class="text-danger" v-if="!$v.itemToEdit.points.minValue">1以上の値を入力してください。</div>
                        <div class="text-danger" v-if="!$v.itemToEdit.points.numeric">数値を入力してください。</div>
                      </dd>
                      <dd class="col-sm-5"></dd>

                      <dt class="col-sm-3">更新理由</dt>
                      <dd class="col-sm-9">
                        <CTextarea
                          class="point-update"
                          placeholder="ポイントの変更理由を入力してください。"
                          horizontal
                          required
                          v-model="itemToEdit.description"
                        />
                      </dd>
                    </dl>
                  </dd>
                </dl>
                <dl class="row">
                  <dd class="col-sm-2"></dd>
                  <dd class="col-sm-2">
                    <CButton
                      @click="addPoints()"
                      color="success"
                      class="float-right"
                      :disabled="$v.$invalid"
                    ><i class="icon cil-pencil"></i> 更新</CButton>
                  </dd>
                </dl>
              </div>
            </CForm>

          </CCardBody>
          <CCardFooter>
            <CButton
              @click="hasHistory() 
              ? $router.go(-1) 
              : $router.push('/')"
              class="my-5 btn btn-dark px-5"
            ><i class="icon cil-arrow-left"></i> 戻る</CButton>
          </CCardFooter>
        </CCard>
      </CCol>
    </CRow>

    <CModal
      color="info"
      closeOnBackdrop
      :centered="true"
      :show.sync="completedModal"
    >
      更新が完了しました。
      <template #header>
      更新完了
      </template>
      <template #footer>
        <CButton @click="completedModal=false" color="secondary">
          <i class="icon cil-x"></i> 閉じる
        </CButton>
      </template>
    </CModal>

    <CModal
      color="danger"
      closeOnBackdrop
      :centered="true"
      :show.sync="failedModal"
    >
      更新に失敗しました。
      <template #header>
      ポイント更新失敗
      </template>
      <template #footer>
        <CButton @click="failedModal=false" color="secondary">
          <i class="icon cil-x"></i> 閉じる
        </CButton>
      </template>
    </CModal>
         

  </div>
</template>

<script>
import axios from "axios";
import { required, minValue, numeric } from "vuelidate/lib/validators";

export default {
  name: "Point",
  components: {},
  data() {
    return {
       
      editingModal: false,
      gUserName: "",

      afterPoints: 0,
      completedModal: false,
      failedModal: false,
      increaseButton: "＋",
      canSearch: false,
      searchResult: "",
      collapse: false,
      user: {
        familyName: "",
        givenName: "",
      },
      increaseOptions: [
        { value: true, label: "＋" },
        { value: false, label: "－" },
      ],
      loading: false,
      loadingsvg: require("../assets/loading.svg"),
      collapseDuration: 0,
      tableItems: [],
      itemToEdit: {
        points: "",
        increase: true,
        description: "",
        familyName: "",
        givenName: "",
        gender: "",
        birth: "",
      },
    };
  },
  validations: {
    itemToEdit: {
      points: { required, minValue: minValue(1), numeric },
      increase: { required },
      description: { required },
    },
    afterPoints: { minValue: minValue(0) }
  },
  created() {
    this.gUserName = this.$route.params.userId;
  },
  methods: {
    getUserInformation: function () {
      //Get user infortmation
      var urlRequest = "/rest/users/" + this.gUserName;

      axios
        .get(urlRequest, {
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        })
        .then((resp) => {
          this.user = resp.data;
          this.getPoints();
          console.log("User Data:" + JSON.stringify(this.user));
          this.searchResult = "";
        })
        .catch((err) => {
             

          console.log(err);
          this.searchResult = "会員が見つかりませんでした。";
        });
    },
    saveProfile: function () {
      var urlRequest;
      urlRequest = "/rest/users/" + this.gUserName;
      console.log(this.itemToEdit);
      axios
        .put(urlRequest, this.itemToEdit, {
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        })
        .then((resp) => {
          console.log("User profile updated:" + resp.data);
          this.editingModal = false;
          this.getUserInformation();
        })
        .catch((err) => {
             

          console.log("Updating profile error: " + err);
          this.errors = err;
        });
    },
    getPoints: function () {
      //Get user ポイント更新履歴
      var urlRequest = "/rest/users/" + this.gUserName + "/points";
      this.loading = true;
      axios({
        url: urlRequest,
        method: "GET",
        headers: { Authorization: `Bearer ${this.$keycloak.token}` },
      })
        .then((resp) => {
          this.tableItems = resp.data;
          console.log(resp);
          console.log(this.tableItems);
          this.loading = false;
          this.collapse = true;
        })
        .catch((err) => {
             

          console.log(err);
          this.loading = false;
          this.collapse = false;
        });
    },
    addPoints: function () {
      //Add user points
      var pointRequest = {
        points: this.itemToEdit.points,
        increase: this.itemToEdit.increase,
        modifiedBy: this.$keycloak.userName,
        description: this.itemToEdit.description,
      };
      //Get current user ポイント更新履歴
      console.log(`Bearer ${this.$keycloak.token}`);
      var urlRequest = "/rest/users/" + this.gUserName + "/points";
      this.loading = true;
      axios
        .put(urlRequest, pointRequest, {
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        })
        .then((resp) => {
          console.log(resp.data);
          this.loading = false;
          this.itemToEdit.points = "";
          this.itemToEdit.increase = true;
          this.itemToEdit.description = "";
          this.getPoints();
          this.completedModal = true;
        })
        .catch((err) => {
           
          console.log(err);
          this.loading = false;
          this.failedModal = true;
        });
    },
    calcAfterPoints: function () {
      // Calcurate points
      const current = +this.tableItems.points;
      const change = +this.itemToEdit.points;
      this.afterPoints = this.itemToEdit.increase
        ? current + change
        : current - change;
      return this.afterPoints;
    },
    swichIncrease: function () {
      this.itemToEdit.increase = !this.itemToEdit.increase;
      this.increaseButton = this.itemToEdit.increase ? "＋" : "－";
    },
    hasHistory() {
      return window.history.length > 2;
    },
    getDisplayName() {
      return this.user.familyName + ' ' + this.user.givenName;
    }
  },
  beforeMount() {
    this.getUserInformation();
  },
};
</script>
